module.exports = __webpack_public_path__ + "img/0Q3C6212_Black_MockedUp.2c763127.jpg";